"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumsArray = exports.AspectRatioArray = exports.GridTypeArray = exports.KeyValueGridType = exports.MobileLayoutTypeArray = exports.KeyValueMobLayout = void 0;
var KeyValueMobLayout;
exports.KeyValueMobLayout = KeyValueMobLayout;

(function (KeyValueMobLayout) {
  KeyValueMobLayout["CAROUSEL"] = "carousel";
  KeyValueMobLayout["SCROLL"] = "scroll";
  KeyValueMobLayout["STACK"] = "stack";
  KeyValueMobLayout["GRID"] = "grid";
})(KeyValueMobLayout || (exports.KeyValueMobLayout = KeyValueMobLayout = {}));

var MobileLayoutTypeArray = Object.values(KeyValueMobLayout);
exports.MobileLayoutTypeArray = MobileLayoutTypeArray;
var KeyValueGridType;
exports.KeyValueGridType = KeyValueGridType;

(function (KeyValueGridType) {
  KeyValueGridType["SMALL"] = "small";
  KeyValueGridType["INSET"] = "inset";
  KeyValueGridType["FULL"] = "full";
})(KeyValueGridType || (exports.KeyValueGridType = KeyValueGridType = {}));

var GridTypeArray = Object.values(KeyValueGridType);
exports.GridTypeArray = GridTypeArray;
var AspectRatioArray = ['3:2', '1:1'];
exports.AspectRatioArray = AspectRatioArray;
var ColumsArray = [2, 3, 4, 5];
exports.ColumsArray = ColumsArray;